module.exports = __webpack_public_path__ + "img/crash.2cf93c0e.svg";